import { Component, OnInit } from '@angular/core';
import { GearManagementService } from '../../../../../../services/gear-management.service';

@Component({
  selector: 'app-gear-type-advices',
  templateUrl: './gear-type-advices.component.html',
  styleUrls: ['./gear-type-advices.component.scss']
})
export class GearTypeAdvicesComponent implements OnInit {

  public advices : any = [];
  public loading : boolean = true;

  constructor(
    public gearManagementService : GearManagementService
  ) { }

  ngOnInit() {
    this.loading = true;
    this.gearManagementService.getGearAdvices().subscribe(advices=>{
      this.advices = advices;
      this.loading = false;
    });
  }

  bikeTypes(){
    return this.advices.map(x=>{return x.bikeType}).filter(this.onlyUnique);
  }

  getAdvices(bikeType){
    var advices = this.advices.filter(x=>{return x.bikeType === bikeType});
    return advices;
  }

  onlyUnique(value, index, self) { 
    return self.indexOf(value) === index;
  }
}
